import { AxiosError } from "axios";
import { retryQueryConfig } from "src/Pages/Company/OrganizationStructure/config/retryQueryConfig";
import { useQuery } from "@tanstack/react-query";
import { IStructureData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";
import { fetchStructureData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";

export const useFetchStructureData = (companyId: string) =>
  useQuery<IStructureData[], AxiosError>({
    queryKey: ["fetch-structure-data", { companyId }],
    queryFn: async ({ signal }) => {
      const data = await fetchStructureData(companyId, { signal });
      return data;
    },
    enabled: !!companyId,
    ...retryQueryConfig,
  });
